const accessLists = {
  header: {
    toolbar: {
      blackList: 'Черный список',
      whiteList: 'Белый список',
    },
    buttons: {
      addNewRecord: 'Добавить новую запись'
    }
  },
  accessLists: 'Списки доступа',
  showing: 'Показано',
  accessListsOf: 'списки доступа',
  noAccessListsFound: 'Списки доступа не найдены',
  modal: {
    category: 'Категория',
    enterCategory: 'Введите категорию',
    value: 'Значение',
    enterValue: 'Введите значение',
    inputValue: 'Пожалуйста, введите значение',
    inputCategory: 'Пожалуйста, введите категорию',
    list_type: 'Тип списка',
    enterListType: 'Пожалуйста, введите тип списка',
    description: 'Описание',
    enterDescription: 'Пожалуйста, введите описание',
    blackList: 'Черный список',
    whiteList: 'Белый Список',
  },
  allCategories: 'Все категории',
  successAdded: 'Добавлено новое значение'
};

export default accessLists;
